import { render } from "./SubscriptionDiscounts.vue?vue&type=template&id=50c2b330&scoped=true"
import script from "./SubscriptionDiscounts.vue?vue&type=script&lang=js"
export * from "./SubscriptionDiscounts.vue?vue&type=script&lang=js"

import "./SubscriptionDiscounts.vue?vue&type=style&index=0&id=50c2b330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c2b330"]])

export default __exports__